<template>
  <div class="d-flex w-100 carte-produit-casino" :class="jel_getClassObject(content)">
    <template v-if="isVisible && produit">
      <CarteImageInfo
        v-if="isProduitLance"
        class="w-100"
        :class="{ produitDesactive: isProduitDesactive }"
        :content="getContentCarteImageInfo()"
        :afficherInfoSecondaire="afficherInfoSecondaire()"
      >
        <template #image>
          <div class="w-100 h-100" @click="jel_forcerClickHyperlien(refRedirection)">
            <MediaImageX3 :show="true" :content="contentMediaImageX3" />
            <span @click.capture="gaPreventClick">
              <b-link
                :ref="refRedirection"
                v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
                class="d-none"
              >
                <!-- conserver pour accessibilité -->
                invisible
              </b-link>
            </span>
          </div>
        </template>

        <template #infoSecondaire>
          <CarteInfoSecondaireDesactivation
            v-if="isProduitDesactive || messageDesactivation"
            :content="{ texteDesactivation: messageDesactivation }"
          />
          <BanniereInfoLotProgressif
            v-else-if="isLotProgressif"
            ref="conteneurLotProgressif"
            :content="{
              produit: produit,
              isListeHorizontale: content.isListeHorizontale,
            }"
          />
          <BanniereInfoMASEnDirect
            v-else-if="isProduitMASEnDirect"
            :content="{
              produit: produit,
            }"
          />
        </template>
        <template #infoPrimaire>
          <CarteInfoPrimaireProduit
            :content="{
              produit: produitCarteInfoPrimaireProduit,
              isListeHorizontale: content.isListeHorizontale,
              cacherSurTitreCategorie: content.cacherSurTitreCategorie === 'true',
              gaEvent: gaEvent,
              gaCategorie: gaCategorie,
              gaTitreProduit: titreProduit,
              gaPosition: positionCarte,
            }"
          />
        </template>
      </CarteImageInfo>
    </template>
    <div
      v-else
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
      }"
      class="chargement w-100 h-100"
    >
      <Carte :content="content" class="w-100">
        <b-skeleton-img no-aspect class="h-50"></b-skeleton-img>
        <div class="h-50">
          <span v-if="produit" class="text-truncate"
            >{{ mixinProduitCasino_getTitre(false) }}...</span
          >

          <div class="row">
            <div class="col-6">
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton width="70%"></b-skeleton>
              <b-skeleton width="85%"></b-skeleton>
            </div>
            <div class="col-6">
              <b-skeleton type="button"></b-skeleton>
            </div>
          </div>
        </div>
      </Carte>
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

import { mapGetters } from 'vuex';
import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

import Carte from '@/components/base/carte/Carte';
import CarteImageInfo from '@/components/base/carte/CarteImageInfo';
import CarteInfoPrimaireProduit from '@/components/casino/carte/CarteInfoPrimaireProduit';
import CarteInfoSecondaireDesactivation from '@/components/casino/carte/CarteInfoSecondaireDesactivation';
import BanniereInfoLotProgressif from '@/components/casino/carte/BanniereInfoLotProgressif';
import BanniereInfoMASEnDirect from '@/components/casino/carte/BanniereInfoMASEnDirect';
import MediaImageX3 from '@/components/media/image/MediaImageX3';
import { isJelMobile } from '@/helpers/AppHelpers';
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  name: 'CarteProduitCasino',
  components: {
    Carte,
    CarteImageInfo,
    CarteInfoPrimaireProduit,
    CarteInfoSecondaireDesactivation,
    BanniereInfoLotProgressif,
    BanniereInfoMASEnDirect,
    MediaImageX3,
  },
  directives: {
    ObserveVisibility,
  },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      isVisible: false,
      refRedirection: this._uid,
    };
  },
  i18n: {
    messages: {
      fr: {
        libelleDemo: 'Essayer la démo',
        libelleFavoris: 'Ajouter aux favoris',
        libelleRegles: 'Règles',
      },
      en: {
        libelleDemo: 'Try the demo',
        libelleFavoris: 'Add to favorites',
        libelleRegles: 'Rules',
      },
    },
  },
  computed: {
    ...mapGetters({
      getProduitCasinoByUuid: 'produitCasino/getByUuid',
      getLienInterneFromProduit: 'produitCasino/getLienInterneFromProduit',
      getStatutProduit: 'produitCasino/getStatutProduit',
      getStatutIntegrateur: 'integrateur/getStatutIntegrateur',
      hasInfoSecondaire: 'produitCasino/hasInfoSecondaire',
    }),
    produit() {
      // On peut recevoir un produit complet ou uniquement son UUID
      return this.content.produit ?? this.getProduitCasinoByUuid(this.content.idProduit);
    },
    isLotProgressif() {
      return (this.produit && this.produit.idProgressif) ?? false;
    },
    isProduitMASEnDirect() {
      return (
        (this.produit &&
          this.produit.image4 &&
          this.produit.image4['@name'] &&
          this.produit.categorie == 'mas' &&
          this.produit.typeJeu == 'masEnDirect') ??
        false
      );
    },
    contentMediaImageX3() {
      // TODO: Ce code est dupliqué, le déplacer dans le store casinoProduit
      const content = this.getContentCarteImageInfo();

      content.formatRatio = '16x9'; // TODO: revoir le format si nécessaire

      if (!content.image) {
        content.image = this.$store.state.produitCasino.imageDefaut;
      }
      return content;
    },
    produitDesactivation() {
      return this.getStatutProduit(this.produit, isJelMobile());
    },
    isProduitDesactive() {
      return this.produitDesactivation?.indDesactive;
    },
    integrateurProduitDesactivation() {
      const integrateurDesactive = this.getStatutIntegrateur(
        this.produit.integrateur,
        this.$isMobile()
      );
      return integrateurDesactive;
    },
    isIntegrateurProduitDesactive() {
      return this.integrateurProduitDesactivation?.indDesactive;
    },
    messageDesactivation() {
      if (this.isIntegrateurProduitDesactive) {
        return undefined;
      }
      if (this.isProduitDesactive) {
        return this.produit.txtDesactivation;
      }
      if (this.produitDesactivation?.message) {
        return this.produit.txtDesactivation;
      }
      return undefined;
    },

    produitCarteInfoPrimaireProduit() {
      return {
        ...this.produit,
        lienInternePageProduit: this.getLienInterneFromProduit(this.produit, 'mode=lancer'),
      };
    },
    isProduitLance() {
      return Date.now() >= Date.parse(this.produit?.dateLancement);
    },
    gaCategorie() {
      // Si l'élément parent est une liste Horizontale
      const listeItems = this.$parent.items ?? null;
      if (listeItems) {
        return 'CJC - Carte de jeu collection';
      }
      return 'CJ - Carte de Jeu';
    },
    gaEvent() {
      // Si l'élément parent est une liste Horizontale
      const listeItems = this.$parent.items ?? null;
      if (listeItems) {
        return 'ga-cjc-click';
      }
      return 'ga-cj-click';
    },
    titreProduit() {
      let libelle = '';
      // Si l'élément parent est une liste Horizontale
      const listeItems = this.$parent.items ?? null;
      if (listeItems) {
        // On ajoute le titre de la Collection Parent au libellé
        const titreCollectoionParent = this.$parent.$parent.contentTitre ?? null;
        if (titreCollectoionParent) {
          libelle += `Collection ${titreCollectoionParent.titre} - `;
        }
      }
      // On récupère le titre du Jeu
      libelle +=
        this.$i18n.locale !== 'en' ? `Jeu ${this.produit.titreFr}` : `Jeu ${this.produit.titreEn}`;
      return libelle;
    },
    positionCarte() {
      let position = 0;
      // Si l'élément parent est une liste Horizontale
      const listeItems = this.$parent.items ?? null;
      if (listeItems) {
        // On récupère la position de la carte dans la liste Horizontale
        for (let i = 0; i < listeItems.length; i++) {
          if (listeItems[i].idProduit === this.produit['@id']) {
            position = i + 1;
            break;
          }
        }
      } else {
        const listeCartesProduits = document.getElementsByClassName('carte-produit-casino');
        // Si une seule carte produit est trouvée on retourne la position 0
        if (listeCartesProduits.length == 1) {
          position = 1;
        } else {
          let cpt = 0;
          for (let i = 0; i < listeCartesProduits.length; i++) {
            // Pas dans une liste horizontale
            if (listeCartesProduits[i].offsetParent.className !== 'vue-horizontal-list') {
              // On récupère la position de la carte si plusieurs cartes
              const titreProduitCasino =
                this.$i18n.locale !== 'en' ? this.produit.titreFr : this.produit.titreEn;
              if (listeCartesProduits[i].textContent.indexOf(titreProduitCasino) !== -1) {
                position = cpt + 1;
                break;
              }
              cpt++;
            }
          }
        }
      }
      return position;
    },
  },
  methods: {
    gaPreventClick(evt = null) {
      const event = this.gaEvent;
      const categorie = this.gaCategorie;
      const libelle = this.titreProduit;
      const position = this.positionCarte;
      const emplacement = this.jel_gaGetEmplacement();

      // Ajout datalayer pour ajouter Event click vers Google Analytics
      if (emplacement.indexOf('Collection') === -1) {
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event,
          categorie,
          emplacement: this.jel_gaGetEmplacement(),
          libelle,
          position,
        });
      }
    },

    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
    getContentCarteImageInfo() {
      const nouveauContenu = { ...this.content };
      nouveauContenu.lien = this.mixinProduitCasino_getLienPageProduit();

      nouveauContenu.image = this.produit.image;
      nouveauContenu.image2 = this.produit.image2;
      nouveauContenu.image3 = this.produit.image3;

      nouveauContenu.produitDesactivation = this.isProduitDesactive;

      // test pour centrer l'image
      nouveauContenu.idProgressif = this.produit.idProgressif;

      // Texte alternatif temporaire pour afficher les images
      const altImage = this.mixinProduitCasino_getTitre(false);
      nouveauContenu.altImage = altImage;
      nouveauContenu.altImage2 = altImage;
      nouveauContenu.altImage3 = altImage;
      nouveauContenu.positionnementImage3 = this.produit.positionnementImage3;

      const itemsMenu = {};
      let index = 0;
      // Affiche l'item de menu "démo" en fonction de desktop/mobile
      if (
        (this.$isMobile() && this.produit.demoMobile) ||
        (!this.$isMobile() && this.produit.demoInternet)
      ) {
        itemsMenu[`liensMenu${index++}`] = this.getContentDemo();
      }
      itemsMenu[`liensMenu${index++}`] = this.getContentFavoris();
      itemsMenu[`liensMenu${index}`] = this.getContentRegles();
      nouveauContenu.liensMenu = itemsMenu;
      nouveauContenu.hauteur = this.content.hauteur ? this.content.hauteur : null;
      return nouveauContenu;
    },
    getContentDemo() {
      return {
        libelle: this.$t('libelleDemo'),
        lien: this.getLienInterneFromProduit(this.produit, 'mode=demo'),
      };
    },
    getContentFavoris() {
      // TODO: À compléter
      return {
        libelle: this.$t('libelleFavoris'),
        lien: {
          field: 'lienInterne',
          lienInterne: this.produit.URLfr,
          isDejaNettoye: true,
        },
      };
    },
    getContentRegles() {
      return {
        libelle: this.$t('libelleRegles'),
        lien: this.getLienInterneFromProduit(this.produit),
      };
    },
    afficherInfoSecondaire() {
      return !!(
        this.getStatutProduit(this.produit, isJelMobile())?.indDesactive ||
        this.hasInfoSecondaire(this.produit)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.carte-produit-casino {
  text-decoration: none;
}
p {
  color: black !important;
}
</style>
